<template>
  <div class="body">
    <div class="header">
      <a class="logo" href="javascript:;" @click="$router.push({path:'/'})">
        <img src="../assets/img/logo.svg" alt>
      </a>
      <!-- <a class="menu_btn" href="javascript:;"  @click="$router.push('more')">
        <img src="../assets/img/menu.png" alt>
      </a> -->
    </div>
    <div class="box"></div>
    <div class="titlebox" v-for="(item,index) in questions" :key="index">
      <span class="iosimg" v-if="isiOS"></span>
      <span class="androidimg" v-if="isAndroid"></span>
      <span class="androidimg" v-if="isWx"></span>
      <span class="title">
        {{item.questionName}}
        <span v-if="item.type == '3'">(多选)</span>
      </span>
      <span v-if="item.type == '0'" class="text">
        <mt-field
          v-model.trim="item.value"
          v-if="isiOS"
          class="boderIos"
          placeholder="点击输入"
          @change="danhang(item,index)"
        ></mt-field>
        <mt-field
          v-model.trim="item.value"
          v-if="isAndroid"
          class="boder"
          placeholder="点击输入"
          @change="danhang(item,index)"
        ></mt-field>
        <mt-field
          v-model.trim="item.value"
          v-if="isWx"
          class="boder"
          placeholder="点击输入"
          @change="danhang(item,index)"
        ></mt-field>
      </span>
      <span v-if="item.type == '1'" class="texts">
        <mt-field
          v-model.trim="item.value"
          class="boder"
          placeholder="点击输入"
          type="textarea"
          rows="4"
          @change="duohang(item,index)"
        ></mt-field>
      </span>
      <span v-if="item.type == '2'" class="radio">
        <mt-radio
          v-model="item.value"
          :id="item.id"
          :options="item.xunhuanData"
          @change="danxuan($event,item,index)"
        ></mt-radio>
      </span>
      <span v-if="item.type == '3'" class="radio">
        <mt-checklist
          v-model="item.value"
          :id="item.id"
          :options="item.xunhuanData"
          @change="duoxuan($event,item,index)"
        ></mt-checklist>
      </span>
    </div>
    <div class="btn">
      <span class="button" @click="btn">确定</span>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      detail: "",
      isiOS: false,
      isAndroid: false,
      isWx: false,
      enrollId: "",
      surveyReqDTO: {},
      questions: [],
      id: "",
      surveyReqDTOanswers: []
    };
  },
  // watch: {
  //   value(a, b) {
  //     console.log(a, b);
  //   }
  // },
  created() {
    this.content();
  },
  mounted() {
    this.download();
  },
  methods: {
    danxuan(e, i, j) {
      console.log("i", i);
      console.log("e", e);
      console.log("j", j);
    },
    duoxuan(e, i, j) {
      console.log("i", i);
      console.log("e", e);
      console.log("j", j);
    },
    danhang(i, j) {
      console.log("i", i);
      console.log("j", j);
    },
    duohang(i, j) {
      console.log("i", i);
      console.log("j", j);
    },
    // 判断ios android
    download() {
      let ua = navigator.userAgent.toLowerCase();
      let isAndroid = ua.indexOf("Android") > -1 || ua.indexOf("Adr") > -1; //android终端
      let isiOS = !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      if (isWeixinBrowser()) {
        this.isWx = !this.isWx;
      } else {
        if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
          //ios
          this.isiOS = true;
        } else if (/(Android)/i.test(navigator.userAgent)) {
          //android
          this.isAndroid = true;
        }
      }
      function isWeixinBrowser() {
        return /micromessenger/.test(ua) ? true : false;
      }
    },
    btn() {
      console.log("tag", "");
      for (var i = 0; i < this.questions.length; i++) {
        if (this.questions[i].value == "") {
          return this.MessageBox.alert(
            "请输入第【" + (i + 1) + "】题内容"
          ).then(action => {});
        }
      }
      this.enrollId = localStorage.getItem("enrollId");
      // console.log("id", this.enrollId);
      // console.log("questions", this.questions);
      this.questions.forEach(item => {
        if (item.type == 0) {
          item.options.forEach(i => {
            item.answers.push({
              content: item.value,
              optionId: i.id
            });
          });
        }
        if (item.type == 1) {
          item.options.forEach(i => {
            item.answers.push({
              content: item.value,
              optionId: i.id
            });
          });
        }
        if (item.type == 2) {
          item.answers.push({
            content: "",
            optionId: item.value
          });
        }
        if (item.type == 3) {
          item.value.forEach(i => {
            item.answers.push({
              content: "",
              optionId: i
            });
          });
        }
      });
      this.questions.forEach(res => {
        this.surveyReqDTOanswers.push({
          id: res.id,
          answers: res.answers
        });
      });
      this.surveyReqDTO = {
        id: this.id,
        enrollId: this.enrollId,
        questions: this.surveyReqDTOanswers
      };
      // console.log("surveyReqDTO", this.surveyReqDTO);
      this.$axios
        .postJson("/api/web/phone/survey/answer", this.surveyReqDTO)
        .then(res => {
          if (res.code == 200) {
            // this.$router.push({
            //   path: `/msg`,
            //   query: {
            //     contentId: this.$route.query.contentId,
            //     categoryId: this.$route.query.categoryId,
            //     parentId: this.$route.query.parentId
            //   }
            // });
            // if (!this.checked) {// 是否开具发票
            //   let needInvoice;
            //   if (this.checked) {
            //     needInvoice = 1
            //   } else {
            //     needInvoice = 0
            //   }
            // let apiTicketReqestDTO = JSON.parse(
            //   localStorage.getItem('apiTicketReqestDTO')
            // )
            this.$router.push({
              path: `/msg`,
              query: {
                contentId: this.$route.query.contentId,
                categoryId: this.$route.query.categoryId,
                parentId: this.$route.query.parentId
              }
            })
            // let offlinePayDTO = {
            //   needInvoice: 0,
            //   enrollId: this.enrollId,
            //   totalFare: apiTicketReqestDTO.totalFare
            // }
            // console.log('offlinePayDTO', offlinePayDTO)
            // this.$axios
            //   .postJson(`/api/web/phone/enroll/offlinePay`, offlinePayDTO)
            //   .then(res => {
            //     if (res.code == 200) {
            //       console.log('res', res)
            //       this.$router.push({
            //         path: `/msg`,
            //         query: {
            //           contentId: this.$route.query.contentId,
            //           categoryId: this.$route.query.categoryId,
            //           parentId: this.$route.query.parentId
            //         }
            //       })
            //     } else {
            //       console.log('res', res)
            //       this.MessageBox.alert(res.data.message).then(action => {
            //         this.totalFare = res.data.totalFare
            //       })
            //     }
            //   })
          } else {
            this.MessageBox.alert(res.message).then(action => {});
          }
        });
    },
    content() {
      this.detail = JSON.parse(localStorage.getItem("detail"));
      if (this.detail.contentId.toString() !== this.$route.query.contentId) {
        console.log("tag", "meiyou");
        // window.location.href = `/singup?contentId=${this.$route.query.contentId}&categoryId=${this.$route.query.categoryId}&parentId=${this.$route.query.parentId}`;
        window.location.href = window.location.href.replace(
          "questionnaire",
          "singup"
        );
      } else {
        let conferenceId = this.detail.contentId;
        this.$axios
          .get(`/api/web/phone/survey/detail/${conferenceId}`)
          .then(res => {
            if (res.code == 200) {
              console.log("re1111s", res);
              this.questions = res.data.questions;
              this.questions.forEach(item => {
                item.answers = [];
                if (item.type == 0) {
                  item.value = "";
                } else if (item.type == 1) {
                  item.value = "";
                } else if (item.type == 2) {
                  item.value = "";
                  item.xunhuanData = [];
                  item.options.forEach(i => {
                    item.xunhuanData.push({
                      label: i.optionName,
                      value: i.id.toString()
                    });
                  });
                } else if (item.type == 3) {
                  item.xunhuanData = [];
                  item.value = [];
                  item.options.forEach(i => {
                    item.xunhuanData.push({
                      label: i.optionName,
                      value: i.id.toString()
                    });
                  });
                  item.options.forEach(item => {
                    item.value = [];
                  });
                }
              });
              this.id = res.data.id;
            } else {
              this.MessageBox.alert(res.message).then(action => {});
            }
          });
        const fenxiangdizhi = window.location.href.replace(
          "questionnaire",
          "singup"
        );
        console.log("tag", fenxiangdizhi);
        this.wxShare(
          this.detail.title,
          this.detail.description,
          this.detail.thumbApp,
          fenxiangdizhi
        );
        // console.log("detail", this.detail);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../assets/sass/global.scss";
</style>
<style lang="scss" scoped>
.boder {
  background-image: none;
  /deep/ .mint-cell-wrapper {
    background-image: none;
    background: #f2f2f2;
    border-radius: 7px;
    margin: 10px 0 0 14px;
  }
}

.boderIos {
  background-image: none;
  /deep/ .mint-cell-wrapper {
    padding-left: 4px;
    background-image: none;
    background: #f2f2f2;
    border-radius: 7px;
    margin: 10px 0 0 14px;
  }
}

.radio {
  background-image: none;
  border-radius: 7px;
  /deep/ .mint-radio-label {
    line-height: 32px;
  }
  /deep/ .mint-cell-wrapper {
    background-image: none;
    background: #f2f2f2;
    margin: 0 0 0 14px;
  }
  /deep/ .mint-cell:last-child {
    background-image: none;
    border-radius: 0 0 7px 7px;
  }
  /deep/ .mint-cell:last-child .mint-cell-wrapper {
    border-radius: 0 0 0 7px;
  }
  /deep/ .mint-cell:nth-child(2) {
    background-image: none;
    border-radius: 7px 7px 0 0;
  }
  /deep/ .mint-cell {
    -webkit-tap-highlight-color: transparent;
  }
  /deep/ .mint-cell:nth-child(2) .mint-cell-wrapper {
    border-radius: 7px 7px 0 0;
  }
  /deep/ .mint-radiolist-label {
    -webkit-tap-highlight-color: transparent;
  }
}

.text {
  display: block;
  width: 360px;
  height: 46px;
  // margin: 0 auto;
}
.titlebox {
  position: relative;
  width: 360px;
  border-radius: 7px;
  margin: 15px 0;
  text-align: left;
  .iosimg {
    position: absolute;
    display: inline-block;
    width: 4px;
    height: 15px;
    top: 21px;
    left: 18px;
    background: #31aaf1;
    border-radius: 1px;
  }
  .androidimg {
    position: absolute;
    display: inline-block;
    width: 4px;
    height: 15px;
    top: 19px;
    left: 18px;
    background: #31aaf1;
    border-radius: 1px;
  }
}
.title {
  display: inline-block;
  margin: 16px 8px 0 25px;
  font-size: 16px;
  font-weight: 700;
  color: #232323;
  letter-spacing: 0;
}

.box {
  height: 56px;
}
.body {
  //   position: fixed;
  //   width: 100%;
  //   height: 100%;
  //   background-color: #fff;
  background: #fff;
  min-height: 100vh;
  box-sizing: border-box;
  position: relative;
  overflow: auto;
}
.header {
  height: 54px;
  background: #ffffff;
  border-bottom: 2px solid #f5f5f5;
  top: 0;
  left: 0;
  right: 0;
  position: fixed;
  z-index: 99;
  .logo {
    display: inline-block;
    // width: 133px;
    // height: 38px;
    position: absolute;
    top: 10px;
    left: 15px;
    img{
      height: 35px;
    }
  }
  .menu_btn {
    display: inline-block;
    position: absolute;
    top: 13px;
    right: 13px;
    width: 29px;
    height: 29px;
    -webkit-tap-highlight-color: transparent;
    img {
      width: 100%;
      height: 100%;
    }
  }
}
.btn {
  margin-left: 105px;
  margin-bottom: 10px;
  margin-top: 30px;
  height: 60px;
  .button {
    display: block;
    color: #fff;
    width: 165px;
    height: 42px;
    font-size: 16px;
    line-height: 42px;
    background-image: linear-gradient(190deg, #5fd5f9 0%, #31aaf1 100%);
    box-shadow: 0 3px 9px 0 #9cdbff;
    border-radius: 25px;
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/questionnaire.vue